import { Card, Flex, Statistic, message } from "antd";
import React, { useEffect, useState } from "react";
import CountUp from "react-countup";
import { getAllRecords } from "../../api-calls/GetRecordsAPI";
import { GET_REGISTRATIONS_COUNT_API_CONSTANT } from "../../constants/APIConstants";

const formatter = (value) => <CountUp end={value} separator="," />;

const DashboardComponent = () => {
  const [registrationsCount, setRegistrationsCount] = useState();

  useEffect(() => {
    getAllRegistrationsCounts();
  }, []);

  // method to get count of all Registrations
  const getAllRegistrationsCounts = async () => {
    let response = await getAllRecords(GET_REGISTRATIONS_COUNT_API_CONSTANT);
    console.log("dashboard", response);

    if (response.status) {
      setRegistrationsCount(response.payload?.data);
    } else {
      message.error(response.message);
    }
  };

  return (
    <div>
      <Flex
        justify="space-evenly"
        style={{
          overflow: "hidden",
          flexWrap: "wrap",
        }}
      >
        <Card style={{ width: "300px", margin: "10px" }}>
          <Statistic
            title={<b>Total Registrations Count</b>}
            value={registrationsCount?.allRegistrationsCount}
            formatter={formatter}
          />
        </Card>
        <Card style={{ width: "300px", margin: "10px" }}>
          <Statistic
            title={<b>Games-Team Registrations Count</b>}
            value={
              registrationsCount?.teamGamesRegistrationsCount[0]
                ?.total_registrations
            }
            formatter={formatter}
          />
        </Card>
        <Card style={{ width: "300px", margin: "10px" }}>
          <Statistic
            title={<b>Games-Individual Registrations Count</b>}
            value={
              registrationsCount?.individualGamesRegistrationsCount[0]
                ?.total_registrations
            }
            formatter={formatter}
          />
        </Card>
        <Card style={{ width: "300px", margin: "10px" }}>
          <Statistic
            title={<b>Cultural Event-Team Registrations Count</b>}
            value={
              registrationsCount?.teamCulturalEventRegistrationsCount[0]
                ?.total_registrations
            }
            formatter={formatter}
          />
        </Card>
        <Card style={{ width: "300px", margin: "10px" }}>
          <Statistic
            title={<b>Cultural Event-Individual Registrations Count</b>}
            value={
              registrationsCount?.individualCulturalEventRegistrationsCount[0]
                ?.total_registrations
            }
            formatter={formatter}
          />
        </Card>
      </Flex>
    </div>
  );
};

export default DashboardComponent;
